export const advancedSettingsMessages = {
  "advancedSettings.title": "Advanced Settings",
  "advancedSettings.environmentVariables.title": "Environment Variables",
  "advancedSettings.environmentVariables.subtitle": "Applied before each prompt or session command",
  "advancedSettings.hideDiffWhitespace.title": "Hide whitespace-only changes",
  "advancedSettings.hideDiffWhitespace.subtitle": "Hides unstaged files whose only changes are whitespace or line endings, and ignores indentation and trailing spaces in diffs. Staged files stay visible.",
  "advancedSettings.actions.close": "Close",
} as const
